export default defineNuxtPlugin(() => {
  const router = useRouter();

  router.afterEach(() => {
    setTimeout(() => {
      const win = window as any
      if (typeof win.yotpoWidgetsContainer?.initWidgets === 'function') {
        win.yotpoWidgetsContainer.initWidgets()
      }
      if (typeof win.yotpo?.initWidgets === 'function') {
        win.yotpo.initWidgets()
      }
    }, 500)
  })
})
